<template>
  <div>
    <CCol xl="12" lg="12" md="12" style="margin-top: 20%" v-if="loading">
      <div
        class="sk-wave primary"
        color="success"
        style="margin: auto; width: 10%; top: 50% !important"
      >
        <div class="sk-wave-rect"></div>
        <div class="sk-wave-rect"></div>
        <div class="sk-wave-rect"></div>
        <div class="sk-wave-rect"></div>
        <div class="sk-wave-rect"></div>
      </div>
    </CCol>
    <CCard v-if="!loading" style="margin-top: 20px">
      <CCardHeader>
        <CRow>
          <CCol sm="3"><h5>Choose message type</h5> </CCol>
          <CCol sm="2"
            ><input
              type="radio"
              v-model="messageselect"
              value="allmsg"
            />&nbsp;<span style="font-size: large">All user</span>
          </CCol>
          <CCol sm="3"
            ><input
              type="radio"
              v-model="messageselect"
              value="particularcmsg"
            />&nbsp;<span style="font-size: large">Particular user</span>
          </CCol>
          <CCol sm="3"
            ><input
              type="radio"
              v-model="messageselect"
              value="notConnectUsersMsg"
            />&nbsp;<span style="font-size: large">Bulk Message</span>
          </CCol>
        </CRow>
      </CCardHeader>
      <CCardBody v-if="common">
        <CRow>
          <CCol col="3">
            <label>Message Title</label>
          </CCol>
          <CCol col="5">
            <CInput v-model="messagetitle" type="text" />
          </CCol>
        </CRow>
        <CRow>
          <CCol sm="3"><label>Upload image</label> </CCol>
          <!-- <CCol sm="2"></CCol> -->
          <CCol sm="7">
            <div>
              <input type="file" @change="previewImage" accept="image/*" />
            </div>
            <div>
              <p>
                Progress: {{ uploadValue.toFixed() + "%" }}
                <progress
                  id="progress"
                  :value="uploadValue"
                  max="100"
                ></progress>
              </p>
              <br />
              <button
                @click="onUpload"
                v-if="uploadbtn"
                class="btn btn-info btn-block"
                style="width: auto"
              >
                Upload
              </button>
            </div>
            <div v-if="imageData != null">
              <img
                class="preview"
                :src="picture"
                style="
                  width: 100px;
                  height: 100px;
                  float: right;
                  margin-top: -100px;
                "
              />
              <br />
            </div>
          </CCol>
        </CRow>
        <!-- <CRow>
          <CCol col="3">
            <label>Url</label>
          </CCol>
          <CCol col="5">
            <CInput v-model="messageurl" type="text" />
          </CCol>
        </CRow> -->
        <CTextarea
          label="Message"
          placeholder="Type here..."
          horizontal
          rows="4"
          v-model="messagetext"
        />

        <CButton color="success" style="float: right" @click="savemsg()"
          >send message</CButton
        >
      </CCardBody>
      <CCardBody v-if="particular">
        <CRow>
          <CCol col="3">
            <label>Message Title</label>
          </CCol>
          <CCol col="5">
            <CInput v-model="messagetitle" type="text" />
          </CCol>
        </CRow>
        <CRow>
          <CCol sm="3"><label>Upload image</label> </CCol>
          <!-- <CCol sm="2"></CCol> -->
          <CCol sm="7">
            <div>
              <input type="file" @change="previewImage" accept="image/*" />
            </div>
            <div>
              <p>
                Progress: {{ uploadValue.toFixed() + "%" }}
                <progress
                  id="progress"
                  :value="uploadValue"
                  max="100"
                ></progress>
              </p>
              <br />
              <button
                @click="onUpload"
                v-if="uploadbtn"
                class="btn btn-info btn-block"
                style="width: auto"
              >
                Upload
              </button>
            </div>
            <div v-if="imageData != null">
              <img
                class="preview"
                :src="picture"
                style="
                  width: 100px;
                  height: 100px;
                  float: right;
                  margin-top: -100px;
                "
              />
              <br />
            </div>
          </CCol>
        </CRow>
        <CRow>
          <CCol col="3">
            <label>Email address</label>
          </CCol>
          <CCol col="5">
            <CInput v-model="tokenaddress" type="text" />
          </CCol>
        </CRow>
        <!-- <CRow>
          <CCol col="3">
            <label>Url</label>
          </CCol>
          <CCol col="5">
            <CInput v-model="messageurl" type="text" />
          </CCol>
        </CRow> -->
        <CTextarea
          label="Message"
          placeholder="Type here..."
          horizontal
          rows="4"
          v-model="messagetext"
        />
        <CButton
          color="success"
          style="float: right"
          @click="saveparticularmsg()"
          >send message</CButton
        >
      </CCardBody>

      <CCardBody v-if="messageselect == 'notConnectUsersMsg'">
        <CRow>
          <CCol col="3">
            <label>Message Title</label>
          </CCol>
          <CCol col="5">
            <CInput v-model="messagetitle" type="text" />
          </CCol>
        </CRow>

        <!-- <CRow>
          <CCol col="3">
            <label>Url</label>
          </CCol>
          <CCol col="5">
            <CInput v-model="messageurl" type="text" />
          </CCol>
        </CRow> -->
        <CTextarea
          label="Message"
          placeholder="Type here..."
          horizontal
          rows="4"
          v-model="messagetext"
        />
        <CRow>
          <CCol sm="3"><label>Upload image</label> </CCol>
          <!-- <CCol sm="2"></CCol> -->
          <CCol sm="7">
            <div>
              <input type="file" @change="previewImage" accept="image/*" />
            </div>
            <div>
              <p>
                Progress: {{ uploadValue.toFixed() + "%" }}
                <progress
                  id="progress"
                  :value="uploadValue"
                  max="100"
                ></progress>
              </p>
              <br />
              <button
                @click="onUpload"
                v-if="uploadbtn"
                class="btn btn-info btn-block"
                style="width: auto"
              >
                Upload
              </button>
            </div>
            <div v-if="imageData != null">
              <img
                class="preview"
                :src="picture"
                style="
                  width: 100px;
                  height: 100px;
                  float: right;
                  margin-top: -100px;
                "
              />
              <br />
            </div>
          </CCol>
        </CRow>
        <CRow>
          <CCol sm="3"><label>Upload CSV</label> </CCol>
          <!-- <CCol sm="2"></CCol> -->
          <CCol sm="7">
            <div>
              <input type="file" @change="csvUpdate" />
            </div>
            <div v-if="emailLists.length > 0" class="w-100">
              <p class="text-info">Total {{ emailLists.length }} Email's</p>
            </div>
          </CCol>
        </CRow>

        <CButton
          color="success"
          style="float: right"
          :disabled="loading"
          @click="saveNotConnected()"
          >send message</CButton
        >
      </CCardBody>
    </CCard>
  </div>
</template>
<script>
import axios from "axios";
import firebase from "firebase";
const db = firebase.firestore();
import Swal from "sweetalert2";
import { APIService } from "../../apiservice.js";
import Papa from "papaparse";

export default {
  data() {
    return {
      uploadbtn: false,
      imageData: null,
      picture: null,
      uploadValue: 0,
      messagetitle: "",
      messagetext: "",
      messageurl: "",
      tokenaddress: "",
      common: false,
      particular: false,
      messageselect: "",
      isAlluser: false,
      isParticularuser: false,
      emailLists: [],
      loading: false,
      fields: [
        {
          label: "Date",
          key: "date",
          sortable: true,
        },
        {
          label: "alluserlist",
          key: "alluserlist",
          sortable: true,
        },
        {
          label: "particularlist",
          key: "particularlist",
          sortable: true,
          _style: "text-align: initial;",
        },

        {
          label: "Message",
          key: "messagetext",
          sortable: true,
        },
        {
          key: "Action",
          sortable: true,
        },
      ],
    };
  },
  watch: {
    messageselect() {
      if (this.messageselect == "allmsg") {
        this.common = true;
        this.particular = false;
        this.isAlluser = true;
        this.isParticularuser = false;
      } else if (this.messageselect == "particularcmsg") {
        this.particular = true;
        this.common = false;
        this.isParticularuser = true;
        this.isAlluser = false;
      } else if (this.messageselect == "notConnectUsersMsg") {
        this.particular = false;
        this.common = false;
        this.isParticularuser = false;
        this.isAlluser = false;
      }
    },
  },
  methods: {
    previewImage(event) {
      this.uploadValue = 0;
      this.picture = null;
      this.imageData = event.target.files[0];
      this.uploadbtn = true;
    },
    csvUpdate(event) {
      console.log("csv ", event.target.files[0]);
      const that = this;
      let fname = event.target.files[0].name.split(".");
      if (fname[1].toLowerCase() == "csv" || fname[1].toLowerCase() == "xlsx") {
        const fileToLoad = event.target.files[0];
        const reader = new FileReader();
        reader.onload = (fileLoadedEvent) => {
          Papa.parse(fileLoadedEvent.target.result, {
            header: true,
            complete(results) {
              let csvdata = [];
              let emailData = [];
              // console.log(
              //   "results.data[i].email",
              //   typeof results.data[0].email,
              //   typeof results.data[0].email == "string"
              // );
              for (let i = 0; i < results.data.length; i++) {
                csvdata.push(results.data[i]);
                if (
                  typeof results.data[i].email == "string" &&
                  results.data[i].email.length > 0
                ) {
                  emailData.push(results.data[i].email);
                }
              }
              that.emailLists = emailData;
              console.log("lenght", that.emailLists.length);

              console.log("this.token.csvdata", that.emailLists);

              // that.doc = JSON.stringify(results.data, null, 2);
              // that.$emit("result", results.data);
            },
            error(errors) {
              console.log("error", errors);
            },
          });
        };
        reader.readAsText(fileToLoad);
      } else {
        // document.getElementById("fileInput").value = "";
      }
    },

    onUpload() {
      this.picture = null;
      var timestamp = new Date().toISOString().replace(/[-:.]/g, "");
      var random = ("" + Math.random()).substring(2, 8);
      var random_number = timestamp + random;
      var fileextension = this.imageData.name.split(".")[1];
      const storageRef = firebase
        .storage()
        .ref(`cloudmessage/${random_number}.${fileextension}`)
        .put(this.imageData);
      storageRef.on(
        `state_changed`,
        (snapshot) => {
          this.uploadValue =
            (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
        },
        (error) => {
          console.log(error.message);
        },
        () => {
          this.uploadValue = 100;
          storageRef.snapshot.ref.getDownloadURL().then((url) => {
            this.picture = url;
            if (this.picture.length > 0) {
              this.uploadbtn = false;
            }
          });
        }
      );
    },
    saveNotConnected() {
      let messagetitle = this.messagetitle;
      let messagetext = this.messagetext;
      let picture = this.picture;
      // let url = this.messageurl;

      if (this.emailLists.length > 0) {
        try {
          this.loading = true;

          let data = {
            messagetitle,
            messagetext,
            picture,
            sendList: this.emailLists,
          };
          console.log("loggg", data);
          axios
            .post(
              "https://us-central1-token-geomine.cloudfunctions.net/adminApi/pointNotification",
              { ...data }
            )
            .then((res) => {
              this.loading = false;
              if (res.status == 200) {
                // console.log("res", res);

                Swal.fire({
                  position: "center",
                  icon: "success",
                  title: "Message send Successfully",
                  showConfirmButton: false,
                  timer: 2000,
                });
                setTimeout(() => {
                  window.location.reload();
                }, 3000);
              }
            });
        } catch (error) {
          this.loading = false;
        }
      }
    },
    savemsg() {
      var date = new Date();

      let messagetitle = this.messagetitle;
      let messagetext = this.messagetext;
      let picture = this.picture;
      // let url = this.messageurl;

      let data = {
        messagetitle,
        messagetext,
        picture,
      };
      // APIService.sendAlluser(data).then((res) => {
      // axios.post("http://localhost:5000/token-geomine/us-central1/adminApi/sendAlluser", { ...data }).then((res) => {
      axios
        .post(
          "https://us-central1-token-geomine.cloudfunctions.net/adminApi/sendAlluserTopic",
          { ...data }
        )
        .then((res) => {
          if (res.status == 200) {
            // console.log("res", res);
            //  console.log("res", res.data.data);
            // db.collection("messagecount").add({
            //   date: date,
            //   messagetitle: this.messagetitle,
            //   messagetext: this.messagetext,
            //   image: this.picture,
            //   messagecount:res.data.data
            // });
            Swal.fire({
              position: "center",
              icon: "success",
              title: "Message send Successfully",
              showConfirmButton: false,
              timer: 2000,
            });
            setTimeout(() => {
              window.location.reload();
            }, 3000);
          }
        });
    },
    saveparticularmsg() {
      var date = new Date();
      // db.collection("messagetest")
      //   .add({
      //     date: date,
      //     messagetitle: this.messagetitle,
      //     isAlluser: this.isAlluser,
      //     isParticularuser: this.isParticularuser,
      //     messagetext: this.messagetext,
      //     tokenaddress: this.tokenaddress,
      //     // messageurl: this.messageurl,
      //     image: this.picture,
      //   })
      //   .then(() => {
      ///apicall

      let messagetitle = this.messagetitle;
      let tokenaddress = this.tokenaddress;
      let messagetext = this.messagetext;
      let picture = this.picture;
      // let url = this.messageurl;

      let data = {
        messagetitle,
        tokenaddress,
        messagetext,
        picture,
        // url,
      };
      // APIService.sendParticularuser(data).then((res) => {
      // axios.post("http://localhost:5000/token-geomine/us-central1/adminApi/sendParticularuser", { ...data }).then((res) => {
      axios
        .post(
          "https://us-central1-token-geomine.cloudfunctions.net/adminApi/sendParticularuser",
          { ...data }
        )
        .then((res) => {
          console.log("res", res);
          console.log("res.status", res.status);
          if (res.status == 200) {
            Swal.fire({
              position: "center",
              icon: "success",
              title: "Message send Successfully for particular user",
              showConfirmButton: false,
              timer: 2000,
            });
          } else if (res.status == 403) {
            Swal.fire({
              position: "center",
              icon: "error",
              title: "Token address not available for this email",
              showConfirmButton: false,
              timer: 2000,
            });
          } else {
            Swal.fire({
              position: "center",
              icon: "error",
              title: "Something went wrong please try after sometime",
              showConfirmButton: false,
              timer: 2000,
            });
          }
          // });
        })
        .catch((error) => {
          console.error("Error writing document: ", error);
        });
    },
  },
  created() {},
};
</script>
